import { downloadPaymentReceipt, getPayments } from "features/Payments/services/PaymentService";
import { PaymentSourceType } from "features/Payments/constants/payment.constants";
import type { PayrollItem } from "features/Payroll/types/payroll.types";

/** Looks up the Payment created behind a PAID payroll item, then downloads its receipt. */
export async function downloadPayrollItemReceipt(item: PayrollItem): Promise<void> {
  const res = await getPayments({
    sourceType: PaymentSourceType.PAYROLL_ITEM,
    sourceId: item.id,
    limit: 1,
  });
  const payment = res.success ? res.data?.rows?.[0] : undefined;
  if (!payment) {
    throw new Error("No payment found for this payroll item.");
  }
  await downloadPaymentReceipt(payment.id, payment.code);
}
